<template>
  <div>
    <Modal
      class="editBlock servelistModal"
      v-model="modal"
      :title="newServeStatus ? '创建新客服':'编辑客服'"
      width="35"
      footer-hide
    >
      <div class="bodyhigh">
        <div class="bodytwice">
          <div class="content">
            <Row>
              <Col span="12">
                <label>帐号</label>
                <Input
                  v-if="!newServeStatus"
                  class="editInput account"
                  v-model="form.account"
                  type="text"
                  disabled
                ></Input>
                <Input v-else class="editInput account" v-model="form.account" type="text"></Input>
              </Col>
              <Col offset="1" span="11">
                <label>組織</label>
                <Select class="editInput department" v-model="form.depaid">
                  <!-- <Option
                    v-for="(item,idx) in depalist"
                    :value="item.depaid"
                    :key="idx"
                  >{{item.depaname}}</Option>-->
                  <Option :value="1">12彩</Option>
                </Select>
              </Col>
            </Row>
            <div class="bodytwice-bottom">
              <Row>
                <Col span="12">
                  <label>昵称</label>
                  <Input class="editInput" v-model="form.nickname" type="text"></Input>
                </Col>
                <Col offset="1" span="11">
                  <label>手机</label>
                  <Input class="editInput cellphone" v-model="form.phnum" type="text"></Input>
                  <p v-if="allStatus.cellphoneStatus" class="cellphoneHint">請輸入數字</p>
                </Col>
              </Row>
              <Row>
                <Col v-if="newServeStatus" span="12">
                  <label>密码</label>
                  <Input
                    class="editInput"
                    v-model="form.pswd"
                    type="password"
                    autocomplete="new-password"
                  ></Input>
                </Col>
                <Col v-if="newServeStatus" span="12" class="passwordAgain">
                  <label>确认密码</label>
                  <Input
                    class="editInput"
                    v-model="passwordAgain"
                    type="password"
                    autocomplete="new-password"
                  ></Input>
                  <p v-if="allStatus.different">密码不相同</p>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div v-if="!newServeStatus" class="btn" @click="editConfirm">储存</div>
          <div v-else class="btn" @click="addConfirm">提交</div>
          <div class="btn" @click="reset">重置</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalForm",
  props: {
    serveStatus: {
      type: Boolean,
      required: true
    },
    depalist: {
      type: Array,
      required: true
    },
    newServeStatus: Boolean,
    maobj: Object
  },
  data () {
    return {
      form: {
        account: '',
        nickname: '',
        phnum: '',
        pswd: '',
        depaid: '',
        // 新增客服預設圖
        image: `${process.env.VUE_APP_PICTURL}/csimg/1419201520200409113443.jpge`,
      },
      allStatus: {
        different: false,
        cellphoneStatus: false,
      },
      passwordAgain: '',
      tempoMa: ''
    }
  },
  watch: {
    maobj () {
      this.tempoMa = JSON.parse(JSON.stringify(this.maobj))
      this.form.depaid = this.tempoMa.depaid
      this.form.account = this.tempoMa.account
      this.form.nickname = this.tempoMa.nickname
      this.form.phnum = this.tempoMa.phnum
    }
  },
  computed: {
    ...mapGetters(['username']),
    modal: {
      get () {
        return this.serveStatus
      },
      set (val) {
        this.reset()
        this.$emit("update:maobj", {})
        this.$emit("update:serveStatus", val)
        this.$emit("update:newServeStatus", false)
        this.form.pswd = ''
        this.passwordAgain = ''
      }
    }
  },
  methods: {
    //提交确定
    addConfirm () {
      if (this.cellphoneJadge(this.form.phnum)) return;
      if (this.form.pswd != this.passwordAgain) {
        this.allStatus.different = true
        return
      }
      const check = Object.keys(this.form).some(it => !this.form[it])
      if (check) {
        this.$Message.error("栏位皆为必填");
        return
      }
      let obj = {
        maid: Number(this.username.maid),
        insType: "0",
        ...this.form
      }
      this.$axios.addmana(obj)
        .then(res => {
          this.$emit("getServeData")
          this.allStatus.different = false
          if (res.status == 0) {
            this.$Message.error(res.msg);
          }
        })
        .catch(err => console.error(err))
      this.reset()
      this.modal = false
    },
    //编辑确定
    editConfirm () {
      if (!this.form.account || !this.form.phnum || !this.form.nickname || !this.form.depaid) {
        this.$Message.error("栏位皆为必填");
        return
      }
      if (this.cellphoneJadge(this.form.phnum)) return;
      let obj = {
        id: Number(this.maobj.maid),
        nickname: this.form.nickname,
        phnum: this.form.phnum,
        depaid: this.form.depaid,
        updatetype: "1"
      }
      this.$axios.updpersonal(obj)
        .then(res => {
          this.$emit("getServeData")
        })
        .catch(err => console.error(err))
      this.reset()
      this.modal = false
    },

    //reset
    reset () {
      if (!this.newServeStatus) {
        this.form.phnum = ''
        this.form.nickname = ''
        this.form.depaid = ''
      } else {
        this.form.account = ''
        this.form.nickname = ''
        this.form.pswd = ''
        this.passwordAgain = ''
        this.form.phnum = ''
        this.form.depaid = ''
      }
    },
    cellphoneJadge (val) {
      if (isNaN(Number(val))) {
        this.allStatus.cellphoneStatus = true
      } else {
        this.allStatus.cellphoneStatus = false
      }
      return this.allStatus.cellphoneStatus
    }
  }
}
</script>
<style lang="less">
.servelistModal {
  .editInput {
    &.cellphone {
      width: 76%;
      margin-left: 15px;
    }
    &.account {
      margin-left: 7px;
    }
    &.email {
      width: 90%;
    }
    &.department {
      margin-left: 15px;
      width: 76%;
    }
  }
  .passwordAgain {
    p {
      color: var(--main-red);
      margin-top: -10px;
      margin-left: 70px;
    }
  }
  .cellphoneHint {
    margin-left: 50px;
    margin-top: -8px;
    color: var(--main-red);
  }
}
</style>